module.exports = __webpack_public_path__ + "img/default_avatar.8bfd68f0.png";